import {
    Button,
    Checkbox,
    Dialog,
    FormControl,
    FormControlLabel,
    FormHelperText,
    SwipeableDrawer,
    Switch,
    TextField,
} from '@material-ui/core';
import { ArnPayloadType } from '../ExploreMFs/types';
import { connect, useDispatch } from 'react-redux';
import SwitchRight from './SwitchRight';
import { useFormik } from 'formik';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { InvestMentMode } from './InvestmentMode';
import { useHistory, useLocation } from 'react-router';
import { validateArn } from '../../../../redux-store/actions/newPurchase';
import en from '../../../../lang/en-us';
import { IsAllow, PlanTypes } from '../../../../redux-store/types/portfolio';
import { switchScheme } from '../../../../redux-store/actions/commercialTransactions';
import { CommercialRootPath } from '../routeConfig';
import * as yup from 'yup';
import {
    OTPACTION,
    MAX_LENGTHS,
    SwitchApiDataKeyType,
    SwitchApiRequestSchemeOptionsType,
    SwitchFlowType,
    SwitchPaths,
} from './types';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { isError, showHelperText, validateHelper } from './utils';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { isMobileDevice, OTP_ACTIONS, SWITCH } from '../../../../utils/constants';
import { getNewSchemeDetail } from '../../../../redux-store/actions/commercialTransactions';
import {
    schemeDetailArrayIndices,
    schemeDetailsNewType,
    schemeDetailsRequestType,
    schemeDetailsResponseType,
} from '../../../../redux-store/types/commercialTransactions';
import { decimalFix } from '../../portfolios/utils';
import IdcwOptions, { idcwDetailsType } from '../IdcwOptions';
import { DEFAULT_MAX_INVESTMENT } from '../../../../utils/constants';
import { shouldAllowDecimal } from '../utils';
import { FaqLink } from '..';
import { RtaSchemeLoadingDialog } from '../AdditionalPurchase/ap-invest';
import { NomineePopup } from '../../NomineePopup';

const { dbCommercial, common } = en;

export enum SwitchBy {
    Units = 'Units',
    Amount = 'Amount',
}
type Props = {
    switchScheme: any;
    getNewSchemeDetail: ({
        isin,
        amcCode,
    }: schemeDetailsRequestType) => Promise<schemeDetailsResponseType>;
    sendPhoneOTP: any;
};

enum InvestThrough {
    arn,
    ria,
    direct,
}

enum ArnPayloadKeys {
    ARN = 'ARN',
    EUIN = 'E',
    RIA = 'INA',
}

export type Values = {
    investThrough: InvestThrough;
    riaCode: string;
    arn1: string;
    arn2: string;
    arn3: string;
    euin: IsAllow | string;
    euinCode: string;
    euinDeclaration: boolean;
    redemableUnitsOrAmount: number;
    switchFullAmount: boolean;
    isChecked: boolean;
    switchedTo: SwitchBy;
    riaFlag: string;
};

const getInitValues = (fromScheme: any, toScheme: any) => {
    //const formattedArn = fromScheme?.brokerCode?.replace('ARN-','')
    return {
        investThrough: [PlanTypes.R, PlanTypes.Reggular].includes(toScheme?.plan?.toUpperCase())
            ? InvestThrough.ria
            : InvestThrough.direct,
        riaCode: '',
        arn1: '',
        arn2: '',
        arn3: '',
        euin: '',
        euinCode: '',
        euinDeclaration: false,
        redemableUnitsOrAmount: '' as unknown as number,
        switchFullAmount: false,
        switchedTo: SwitchBy.Amount,
        isChecked: false,
        riaFlag: ArnPayloadKeys.RIA,
    };
};

const SwitchInvestment: React.FunctionComponent<Props> = (props) => {
    const history = useHistory<SwitchFlowType>();
    const dispatch = useDispatch();
    const { switchFromScheme, switchToScheme } = history.location.state || {};
    const amcCode = new URLSearchParams(history.location.search).get('amc');
    if (!switchFromScheme || !switchToScheme) return null;
    const [loading, setLoading] = useState(false);
    const [schemeLoading, setSchemeLoading] = useState(false);
    const [euin, setEuin] = useState(false);
    const [newSchemeDetails, setNewSchemeDetails] = useState<schemeDetailsNewType | null>(null);
    const [activeHandle, setActiveHandle] = useState<boolean>(false);
    const [idcwDetails, setIdcwDetails] = useState<idcwDetailsType | null>(null);
    const convertAmount = (amount: number) => {
        let nav: number;
        //typescript throwing error when using ternary operator
        if (switchFromScheme.nav === undefined) {
            nav = 0;
        } else {
            nav = switchFromScheme.nav;
        }
        const amountInUnits =
            formik.values.switchedTo === SwitchBy.Units ? amount / nav : nav !== 0 ? amount : 0;
        const amountInRupees = formik.values.switchedTo === SwitchBy.Amount ? amount * nav : amount;
        return { amountInUnits, amountInRupees };
    };
    const validate = (values: Values) => {
        return validateHelper(
            values,
            (switchToScheme.plan.toUpperCase() as PlanTypes) || PlanTypes.Reggular,
            !!newSchemeDetails
                ? Number(newSchemeDetails[schemeDetailArrayIndices.switch].switch.minAmount)
                : 0,
            !!newSchemeDetails
                ? Number(newSchemeDetails[schemeDetailArrayIndices.switch].switch.multiples) || 1
                : 1,
        );
    };
    const formik = useFormik<Values>({
        initialValues: getInitValues(switchFromScheme, switchToScheme),
        onSubmit: ({
            arn1,
            arn2,
            arn3,
            riaCode,
            euinCode,
            euinDeclaration,
            investThrough,
            redemableUnitsOrAmount,
            switchFullAmount,
            switchedTo,
        }) => {
            // const { amountInRupees, amountInUnits } = convertAmount(redemableUnitsOrAmount);
            const nav = !!switchToScheme.nav ? switchToScheme.nav : 1;
            const amount =
                switchedTo === SwitchBy.Amount
                    ? redemableUnitsOrAmount
                    : redemableUnitsOrAmount * nav;
            const units =
                switchedTo === SwitchBy.Units
                    ? redemableUnitsOrAmount
                    : redemableUnitsOrAmount / nav;
            const schemeOptionsData: SwitchApiRequestSchemeOptionsType = {
                itemNo: '',
                folio: switchFromScheme.folio.toString(),
                fromIsin: switchFromScheme.isin,
                toIsin:
                    !!newSchemeDetails &&
                    newSchemeDetails[
                        schemeDetailArrayIndices.commonDetails
                    ].isDividend.toLowerCase() === 'false'
                        ? switchToScheme.isin
                        : !!idcwDetails
                        ? idcwDetails.isin
                        : switchToScheme.isin,
                reInvest: !!idcwDetails ? idcwDetails.idcwOption : '',
                amount:
                    switchedTo === SwitchBy.Amount && !switchFullAmount ? amount.toString() : '',
                units:
                    switchedTo === SwitchBy.Units || switchFullAmount
                        ? switchFullAmount
                            ? switchFromScheme.availableUnits.toString()
                            : units.toString()
                        : '',
                allUnits: switchFullAmount ? IsAllow.YES : IsAllow.No,
                trxnDate: '',
                trxnTime: '',
                userTrxnNo: '',
                distId:
                    investThrough === InvestThrough.direct
                        ? 'DIRECT'
                        : !!arn1
                        ? `${ArnPayloadKeys.ARN}-${arn1}`
                        : '',
                subDist: !!arn2 ? `${arn2}` : '',
                subBrokerARN: !!arn3 ? `${ArnPayloadKeys.ARN}-${arn3}` : '',
                euin: !!euinCode ? `${ArnPayloadKeys.EUIN}${euinCode}` : '',
                euinDeclarationFlag: !!euinDeclaration ? IsAllow.YES : IsAllow.No,
                riaCode: !!riaCode ? `${formik.values.riaFlag}${riaCode}` : '',
            };
            const switchAPIDataKey: SwitchApiDataKeyType = {
                amc: switchFromScheme.amc,
                dpid: '',
                source: isMobileDevice() ? 'mobile' : 'web',
                schemeOptions: [schemeOptionsData],
            };
            const validateArnFields = async (Values: ArnPayloadType) => {
                // let test: any = {
                //     amc: 'RMF',
                //     distId: 'ARN-1234',
                //     subDist: 'ARN-3456',
                //     subBrokerARN: '',
                //     euin: '',
                //     euinDeclarationFlag: 'N',
                //     riaCode: '',
                //     planCode: 'REGULAR',
                // };
                try {
                    await dispatch(validateArn(Values));
                    return true;
                } catch (err: any) {
                    throw err;
                }
            };
            async function switchApiCall() {
                try {
                    const apiPayload = {
                        data: [switchAPIDataKey],
                    };
                    const otpPayload = {
                        action: OTP_ACTIONS.switch,
                    };
                    const res = await props.sendPhoneOTP(otpPayload);
                    (history as any).replace(`${CommercialRootPath}${SwitchPaths.SwitchOtp}`, {
                        reqId: res.body.reqId,
                        otpRef: res.body.otpRef,
                        apiPayload: apiPayload,
                    });
                } catch (err: any) {
                    throw err;
                }
            }
            async function callApi() {
                try {
                    if (
                        formik.values.switchedTo === SwitchBy.Amount &&
                        Number(formik.values.redemableUnitsOrAmount) >
                            switchFromScheme.availableAmount
                    ) {
                        throw new Error(dbCommercial.switch.switchFromAmountError);
                    }
                    if (
                        formik.values.switchedTo === SwitchBy.Units &&
                        Number(formik.values.redemableUnitsOrAmount) >
                            switchFromScheme.availableUnits
                    ) {
                        throw new Error(dbCommercial.switch.switchFromUnitError);
                    }
                    let arnPayload: ArnPayloadType = {
                        amc: switchFromScheme.amc,
                        planCode: !!switchToScheme.plan
                            ? (switchToScheme.plan as PlanTypes)
                            : PlanTypes.Reggular,
                        distId: !!formik.values.arn1
                            ? `${ArnPayloadKeys.ARN}-${formik.values.arn1}`
                            : '',
                        subDist: !!formik.values.arn2 ? `${formik.values.arn2}` : '',
                        subBrokerARN: !!formik.values.arn3
                            ? `${ArnPayloadKeys.ARN}-${formik.values.arn3}`
                            : '',
                        riaCode: !!formik.values.riaCode
                            ? `${formik.values.riaFlag}${formik.values.riaCode}`
                            : '',
                        euin: !!formik.values.euinCode
                            ? `${ArnPayloadKeys.EUIN}${formik.values.euinCode}`
                            : '',
                        euinDeclarationFlag: [PlanTypes.R, PlanTypes.Reggular].includes(
                            !!switchToScheme.plan
                                ? (switchToScheme.plan.toUpperCase() as PlanTypes)
                                : PlanTypes.Reggular,
                        )
                            ? !!formik.values.euinDeclaration
                                ? IsAllow.YES
                                : IsAllow.No
                            : '',
                    };
                    setLoading(true);
                    let shouldValidate =
                        [PlanTypes.R, PlanTypes.Reggular].includes(
                            !!switchToScheme.plan
                                ? (switchToScheme.plan.toUpperCase() as PlanTypes)
                                : PlanTypes.Reggular,
                        ) || formik.values.investThrough === InvestThrough.ria;
                    if (shouldValidate) {
                        await validateArnFields(arnPayload);
                    }
                    await switchApiCall();
                } catch (err: any) {
                    alert(err.message);
                } finally {
                    setLoading(false);
                }
            }
            callApi();
        },
        validate,
        validateOnMount: false,
        validateOnBlur: false,
    });
    useEffect(() => {
        if (!switchFromScheme || !switchToScheme) {
            history.push(`${CommercialRootPath}${SwitchPaths.Switch}`);
        }
        async function getSchemeDetails() {
            try {
                setSchemeLoading(true);
                const { body = { data: {} as any } }: schemeDetailsResponseType =
                    await props.getNewSchemeDetail({
                        isin: switchToScheme.isin,
                        amcCode: !!amcCode ? amcCode : '',
                    });
                if (body.data[0].activeFlag === IsAllow.No) {
                    setActiveHandle(true);
                }
                setNewSchemeDetails(body.data);
            } catch (err: any) {
                alert(err.message);
                history.goBack();
            } finally {
                setSchemeLoading(false);
            }
        }
        getSchemeDetails();
    }, []);
    // useEffect(() => {
    //     !!newSchemeDetails &&
    //         formik.setFieldValue(
    //             'redemableUnitsOrAmount',
    //             newSchemeDetails[schemeDetailArrayIndices.switch].switch.minAmount,
    //         );
    // }, [newSchemeDetails]);
    useEffect(() => {
        //Formik is capturing the switchedto value finally, so the calculations are changed accordingly,
        const { amountInRupees, amountInUnits } = convertAmount(
            formik.values.redemableUnitsOrAmount,
        );
        formik.values.switchedTo === SwitchBy.Amount
            ? formik.setFieldValue('redemableUnitsOrAmount', decimalFix(amountInRupees))
            : formik.setFieldValue('redemableUnitsOrAmount', decimalFix(amountInUnits));
    }, [formik.values.switchedTo]);

    const handleAmountChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target.value.length > 22) return;
        formik.setFieldValue('redemableUnitsOrAmount', Number(event.target.value));
        formik.values.switchFullAmount ? formik.setFieldValue('switchFullAmount', false) : null;
    };
    const [show, setShow] = useState<boolean>(false);
    const [openDrawer, setDrawer] = useState<boolean>(false);
    return (
        <div className="curved-bg mf-investment switch-investment mf-payment">
            <h2 className="heading desktop_mode">
                <a onClick={() => history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                <div className="switch-heading">
                    <span>{switchFromScheme.schemeName}</span>
                    <img src="/images/right-arrow-long-purple.svg" alt="icon" />
                    <span>{switchToScheme.schemeName}</span>
                </div>
            </h2>
            <div className="switch-mobile-heading mobile_mode">
                <h2 className="heading">
                    <a onClick={() => history.goBack()}>
                        <img src="/images/left-arrow-black.svg" alt="icon" />
                    </a>
                    {dbCommercial.switch.heading}
                </h2>
                <div className="switch-heading">
                    <div className="switch-mobile-from">
                        <p className="switch-txt">{dbCommercial.switch.from}</p>
                        <p className="switch-title">{switchFromScheme.schemeName}</p>
                    </div>
                    <img
                        className="switch-down-arrow"
                        src="/images/down-arrow-long-purple.svg"
                        alt="icon"
                    />
                    <div className="switch-mobile-to">
                        <p className="switch-txt">{dbCommercial.switch.to}</p>
                        <p className="switch-title">{switchToScheme.schemeName}</p>
                    </div>
                </div>
                <div className="mobile-profile-details">
                    <div className="mobile-profile-details-inner">
                        <h4> {dbCommercial.switch.switchDetails}</h4>
                        <div className="mobile-profile-details-links">
                            <a onClick={() => setDrawer(true)}>
                                View <img src="/images/right-arrow-purple.svg" alt="icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="curved-bg-content">
                <div className="mf-investment-left">
                    <InvestMentMode
                        plan={
                            (switchToScheme.plan.toUpperCase() as PlanTypes) || PlanTypes.Reggular
                        }
                        formikState={formik}
                        setEuin={setEuin}
                    />
                    <div className="investment-details">
                        <h3>
                            <img src="/images/investment-details.svg" alt="icon" />
                            {dbCommercial.exploreMfs.mfInvestment.investmentDetails}
                        </h3>
                        {!!newSchemeDetails &&
                            newSchemeDetails[
                                schemeDetailArrayIndices.commonDetails
                            ].isDividend.toLowerCase() === 'true' && (
                                <IdcwOptions
                                    subPlans={
                                        newSchemeDetails[schemeDetailArrayIndices.subPlans].subPlans
                                    }
                                    setIdcwDetails={setIdcwDetails}
                                />
                            )}
                        <div className="db-portfolio-chart-toggle">
                            <div>
                                <p
                                    style={
                                        formik.values.switchedTo === SwitchBy.Amount
                                            ? { opacity: 1, color: '#3A2F5C' }
                                            : {}
                                    }
                                >
                                    {dbCommercial.redemption.amount}
                                </p>
                                <Switch
                                    name="toggle-chart"
                                    inputProps={{ 'aria-label': 'toggle-chart' }}
                                    value={formik.values.switchedTo}
                                    checked={
                                        formik.values.switchedTo === SwitchBy.Amount ? false : true
                                    }
                                    onChange={() => {
                                        formik.values.switchedTo === SwitchBy.Amount
                                            ? formik.setFieldValue('switchedTo', SwitchBy.Units)
                                            : formik.setFieldValue('switchedTo', SwitchBy.Amount);
                                        formik.setFieldValue('redemableUnitsOrAmount', '');
                                        formik.setFieldValue('switchFullAmount', false);
                                    }}
                                />
                                <p
                                    style={
                                        formik.values.switchedTo === SwitchBy.Units
                                            ? { opacity: 1, color: '#3A2F5C' }
                                            : {}
                                    }
                                >
                                    {dbCommercial.redemption.units}
                                </p>
                            </div>
                        </div>
                        <div className="investment-amount enter-amount">
                            <h4>
                                {dbCommercial.redemption.enter}
                                {formik.values.switchedTo === SwitchBy.Amount
                                    ? SwitchBy.Amount
                                    : SwitchBy.Units}
                            </h4>
                            <TextField
                                value={
                                    !!formik.values.redemableUnitsOrAmount
                                        ? formik.values.redemableUnitsOrAmount
                                        : ''
                                }
                                onChange={(e) => {
                                    if (
                                        shouldAllowDecimal(e.target.value, formik.values.switchedTo)
                                    ) {
                                        formik.setFieldValue(
                                            'redemableUnitsOrAmount',
                                            e.target.value,
                                        );
                                    }
                                }}
                                inputProps={{ inputMode: 'numeric' }}
                                // onFocus={() =>
                                //     formik.setFieldTouched('redemableUnitsOrAmount', true)
                                // }
                                disabled={formik.values.switchFullAmount}
                                name="redemableUnitsOrAmount"
                                id="enter-amount"
                                error={isError(formik, 'redemableUnitsOrAmount')}
                                variant="outlined"
                                helperText={showHelperText(formik, 'redemableUnitsOrAmount')}
                                type="number"
                            />
                            {/* <div className="enter-amount-values">
                                <p>
                                    {switchedTo === SwitchBy.Amount
                                        ? dbCommercial.switch.minSwitchAmount
                                        : dbCommercial.switch.minSwitchUnits}
                                </p>
                                <h5>---</h5>
                            </div> */}
                            {/* <div className="enter-amount-values">
                                <p>{dbCommercial.switch.exitLoad}</p>
                                <h5>---</h5>
                            </div> */}
                        </div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="switchFullAmount"
                                    onChange={() => {
                                        if (!!formik.values.switchFullAmount) {
                                            formik.values.redemableUnitsOrAmount = 0;
                                        } else {
                                            formik.values.switchedTo === SwitchBy.Amount
                                                ? formik.setFieldValue(
                                                      'redemableUnitsOrAmount',
                                                      switchFromScheme.availableAmount,
                                                  )
                                                : formik.setFieldValue(
                                                      'redemableUnitsOrAmount',
                                                      switchFromScheme.availableUnits,
                                                  );
                                        }
                                        formik.setFieldValue(
                                            'switchFullAmount',
                                            !formik.values.switchFullAmount,
                                        );
                                    }}
                                    checked={formik.values.switchFullAmount}
                                />
                            }
                            label={
                                formik.values.switchedTo === SwitchBy.Amount
                                    ? dbCommercial.switch.switchFullAmount
                                    : dbCommercial.switch.switchFullUnits
                            }
                        />
                        <div className="mf-investment-bottom">
                            <div className="disclaimers">
                                <FormControl>
                                    <FormControlLabel
                                        className="inline-checkbox"
                                        control={
                                            <Checkbox
                                                name="terms-conditions"
                                                onChange={() => {
                                                    formik.setFieldValue(
                                                        'isChecked',
                                                        !formik.values.isChecked,
                                                    );
                                                }}
                                                checked={formik.values.isChecked}
                                                disabled={loading}
                                            />
                                        }
                                        label={
                                            <>
                                                {dbCommercial.exploreMfs.mfInvestment.disclaimers}
                                                <a onClick={() => setShow(!show)}>
                                                    {dbCommercial.exploreMfs.mfInvestment.termsLink}
                                                </a>
                                                {dbCommercial.exploreMfs.mfInvestment.of}
                                                <span>
                                                    {dbCommercial.exploreMfs.mfInvestment.mfCentral}
                                                </span>
                                            </>
                                        }
                                    />
                                    {formik.touched.isChecked && (
                                        <FormHelperText
                                            style={{
                                                color: 'red',
                                                fontSize: 14,
                                                textAlign: 'left',
                                            }}
                                        >
                                            {formik.errors.isChecked}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </div>
                            <div className="buttons">
                                <SubmitButtonWithLoader
                                    label={dbCommercial.redemption.proceedBtn}
                                    labelWhileLoading="Submitting.."
                                    loading={loading}
                                    className="customBtn "
                                    disabled={
                                        newSchemeDetails
                                            ? newSchemeDetails[0].swiAllow === IsAllow.No
                                            : false
                                    }
                                    onClick={formik.handleSubmit as any}
                                />
                            </div>
                        </div>
                        <FaqLink section={SWITCH} />
                    </div>
                </div>
                <Dialog
                    onClose={() => history.goBack()}
                    maxWidth={'sm'}
                    open={activeHandle}
                    aria-labelledby="transmission-main-modal"
                >
                    <div className="note-modals transmission-main-modal">
                        <h3>{dbCommercial.exploreMfs.inactiveScheme}</h3>
                        <p>{dbCommercial.exploreMfs.inactiveSchemeInfo}</p>
                        <div className="note-modals-btns">
                            <Button className="customBtn" onClick={() => history.goBack()}>
                                {dbCommercial.exploreMfs.okay}
                            </Button>
                        </div>
                    </div>
                </Dialog>
                <SwitchRight
                    dbCommercial={dbCommercial}
                    switchFromScheme={switchFromScheme}
                    switchToScheme={switchToScheme}
                />
            </div>
            <RtaSchemeLoadingDialog open={schemeLoading} />
            <Dialog fullWidth maxWidth={'lg'} open={show} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.termsConditions}</h2>
                        <a className="close">
                            <img
                                onClick={() => setShow(!show)}
                                src="/images/close-white.svg"
                                alt="icon"
                            />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.termsModal.switch.info1}</p>
                            <p>
                                <b>{dbCommercial.termsModal.switch.note}</b>
                                {dbCommercial.termsModal.switch.info2}
                            </p>
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog fullWidth maxWidth={'lg'} open={euin} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.euinDeclaration}</h2>
                        <a className="close" onClick={() => setEuin(!euin)}>
                            <img src="/images/close-white.svg" alt="icon" />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.euinModal.info}</p>
                        </div>
                    </div>
                </div>
            </Dialog>
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer profile-details-drawer"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.switch.switchDetails}
                        </h5>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="profile-details-drawer">
                            <SwitchRight
                                dbCommercial={dbCommercial}
                                switchFromScheme={switchFromScheme}
                                switchToScheme={switchToScheme}
                                desktopHeading={false}
                            />
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
            <NomineePopup folio={switchFromScheme?.folio.toString()} />
        </div>
    );
};

export default connect(null, { switchScheme, getNewSchemeDetail, sendPhoneOTP })(SwitchInvestment);
